if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      console.log(line_item);
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  //jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback, hideCart) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
      
      if(hideCart) { 
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              id: free_gift_id,
              properties: {
                '_type': 'Free Gift'
              },
              quantity: 0
            },
          success: function (res) {
          	setTimeout(function() {
        		wayfx.RightDrawer.close();
        	}, 1000);
          }});
      }
      
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, buildProgressBar, progressBarStatus, progressBarComplete, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      $//addToCart.removeClass('is-added').addClass('is-adding');
      
      $addToCart.addClass('btn-adding');
      
      // Remove any previous quantity errors
      $('.qty-error').remove();
      
      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    //$addToCart.removeClass('is-adding').addClass('is-added');
    setTimeout(function(){
    	$addToCart.removeClass('btn-adding');
    }, 500);
    
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $('#wayfx_cart_total').html('');
      buildProgressBar(0);
      $cartContainer
          .addClass('cart-container--empty').append('<div class="ajaxcart__empty"><h4 class="h4--primary">Your cart is currently empty.</h4><p>' + "Fill your cart with some amazing ramen." + '</p><a href="/products/variety-pack" class="btn btn--full btn--large btn--primary">Shop Now</a></div>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source),
        eligible_cart_qty = 0,
        line_price_after_discount = 0,
        line_price_discount = 0,
        total_price_after_discount = 0,
        total_discount = 0,
        is_subscription = false,
        checkReCharge = false;
    
    $.each(cart.items, function(index, cartItem) {
      if(cartItem.properties != null && cartItem.properties.shipping_interval_frequency) {
       is_subscription = true;
        checkReCharge = true;
      }
    });
    
    // Add each item to our handlebars.js data
    
    $.each(cart.items, function(index, cartItem) {

      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      
      if(!is_subscription) {
        eligible_cart_qty = eligible_cart_qty + cartItem.quantity;
      }
      
      var productTitle = cartItem.product_title.replace('7.00% Off Auto renew', '').replace('10.00% Off Auto renew', '');
      
      if(eligible_cart_qty >= 3 && !is_subscription) {
        line_price_discount = cartItem.original_line_price * 0.03;
        line_price_after_discount = cartItem.original_line_price - line_price_discount;
      } else {
        line_price_discount = 0;
        line_price_after_discount = cartItem.original_line_price;
      }
      
      total_price_after_discount = total_price_after_discount + line_price_after_discount;
      total_discount = total_discount + line_price_discount;
       
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: productTitle,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(line_price_after_discount, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: line_price_after_discount !== cartItem.original_line_price
      };

      items.push(item);
      
    });
    
    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(total_price_after_discount , settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: total_discount !== 0
    }

    var wfxCartTotal = $('#wayfx_cart_total');
    wfxCartTotal.html('(' + cart.item_count + ')');

    $cartContainer.append(template(data));

    cartCallback(cart);
    
    buildProgressBar(eligible_cart_qty, checkReCharge, total_price_after_discount);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  buildProgressBar = function(totalQty, isReCharge, totalPrice) {
    
    var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
    var paramDomain = 'myshopify_domain=immi-eats.myshopify.com';
    try {
      var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
    } catch (err) {
      var paramLinker = '';
    }
    var paramCustomer = '';
        
    var wayfx_cart_drawer = $('#CartDrawer'),
        wayfx_cart_qty = parseInt(totalQty),
        wayfx_progress_percentage = Math.round((totalPrice / 100) / 50 * 100 + 7).toFixed(2),
        wayfx_progress_bar = $('.progress-bar'),
        wayfx_checkout_form = $('#checkoutForm'),
        wayfx_progress_tier_1 = $('.drawer__progress li[data-tier="1"]'),
        wayfx_progress_tier_2 = $('.drawer__progress li[data-tier="2"]'),
        wayfx_progress_text = $('.progress-bar-text'),
        wayfx_discount_tier_1 = 'discount=FREESHIPPING',
        wayfx_discount_tier_2 = 'discount=TASTYRAMEN3';
    if(wayfx_progress_percentage > 100) {
      wayfx_progress_percentage = 100;
    }
    wayfx_progress_bar.css('width', wayfx_progress_percentage + '%');
            
    if(wayfx_cart_qty == 0) {
      wayfx_progress_bar.css('width', '0%');
      wayfx_progress_tier_1.removeClass('completed');
      wayfx_progress_text.html("Spend <strong>$50.00</strong> more to get <strong>Free Shipping</strong>");
      if(isReCharge) {
      	wayfx_checkout_form.attr('action', 'https://checkout.rechargeapps.com/r/checkout?' + paramDomain +  paramCart + paramLinker + paramCustomer);
      } else {
      	wayfx_checkout_form.attr('action', '/checkout?discount=%20');
      }
    } else {
      var remaining = Math.abs((totalPrice / 100) - 50);
      wayfx_progress_text.html("Spend <strong>$" + remaining.toFixed(2) + "</strong> more to get <strong>Free Shipping</strong>");
    }
    
    var hasDiscountCookie = Cookies.get('discount_code');
    
    if(isReCharge || hasDiscountCookie) {
      $("#CartContainer").removeClass('with-progress-bar'); 
      $(".drawer__progress").hide(); 
      $(".drawer__discount").hide();
      $("#drawerDiscount").html('');
    } else {
      $("#CartContainer").addClass('with-progress-bar'); 
      $(".drawer__progress").show(); 
    }
    
    if(!hasDiscountCookie) {
    
      if((totalPrice / 100) < 50) {
        $("#drawerDiscount").html('');
        $(".drawer__discount").hide(); 
        wayfx_progress_tier_1.removeClass('completed');

        if(isReCharge) {
          wayfx_checkout_form.attr('action', 'https://checkout.rechargeapps.com/r/checkout?' + paramDomain +  paramCart + paramLinker + paramCustomer);
        } else {
          wayfx_checkout_form.attr('action', '/checkout?discount=%20');
        }
      }

      if((totalPrice / 100) >= 50) {
        wayfx_progress_tier_1.addClass('completed');
        $("#drawerDiscount").html('FREESHIPPING');
        $(".drawer__discount").show();
        wayfx_progress_text.html("<strong>Congrats! You received Free Shipping</strong>");
        if(isReCharge) {
          wayfx_checkout_form.attr('action', 'https://checkout.rechargeapps.com/r/checkout?' + paramDomain +  paramCart + paramLinker + paramCustomer);
        } else {
          wayfx_checkout_form.attr('action', '/checkout?' + wayfx_discount_tier_1);
        }
      }
      
    }
  }

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
        return false;
      } else {
        $qtySelector.val(qty);
      }
    });

    $body.on('click', '.ajaxcart__qty--remove', function() {
      var $el = $(this),
          line = $el.data('line');

      updateQuantity(line, 0);
      return false;
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
        return false;
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading'),
          builderCount = parseInt($('.wayfx-builder-header__current-count').html());

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 200);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 100)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = parseInt($el.val());

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = parseInt($el.val()),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));
        
        var qty = validateQty(qty);

        // Add, subtract, or remove from the current quantity
        if (($el.hasClass('ajaxcart__qty--plus') || ($el.hasClass('js-qty__adjust--plus')))) {
          qty++;
        }

         if (($el.hasClass('ajaxcart__qty--minus') || ($el.hasClass('js-qty__adjust--minus')))) {
          qty--;
          if (qty <= 0) qty = 1;
        }

        if ($el.hasClass('ajaxcart__qty--remove')) {
          qty = 0;
        }

        // Update the input's number
        setTimeout(function() {
          $qtySelector.val(qty);
        }, 110);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));